import Content from '@/components/layout/Content.vue';
import Names from '@/router/names';
import { isAuth } from '@/services/PermissionService';
import { B2B_VIEW_COMPANY_DETAILS, hasPermission, POS_B2B_VIEW_ORDERS, SUPER_ADMIN } from '@/middlewares/permissions';

export default {
	path: '/b2bOrders',
	slug: 'b2bOrders',
	component: Content,
	children: [
		{
			path: '/b2bOrders',
			redirect: '/b2bOrders/kanban',
		},
		{
			path: 'weeklyPlan',
			name: Names.B2B_WeeklyPlan,
			component: () => import('../views/b2bOrders/B2bWeeklyPlan.vue'),
			meta: {
				title: 'B2B_WeeklyPlan',
				middleware: [isAuth, (nav) => hasPermission(nav, [POS_B2B_VIEW_ORDERS], [SUPER_ADMIN])],
			},
		},
		{
			path: 'kanban',
			name: Names.B2B_Kanban,
			component: () => import('../views/b2bOrders/B2BKanban.vue'),
			meta: {
				title: 'B2B_Kanban',
				middleware: [isAuth, (nav) => hasPermission(nav, [POS_B2B_VIEW_ORDERS], [SUPER_ADMIN])],
			},
		},
		{
			path: 'list',
			name: Names.B2B_OrdersList,
			component: () => import('../views/b2bOrders/B2bOrdersList.vue'),
			meta: {
				title: 'B2B_OrdersList',
				middleware: [isAuth, (nav) => hasPermission(nav, [POS_B2B_VIEW_ORDERS], [SUPER_ADMIN])],
			},
		},
		{
			path: 'companyOrdersList',
			name: Names.CompanyOrdersList,
			component: () => import('../views/company/CompanyOrdersList.vue'),
			meta: {
				title: 'CompanyOrdersList',
				middleware: [isAuth, (nav) => hasPermission(nav, [B2B_VIEW_COMPANY_DETAILS], [SUPER_ADMIN])],
			},
		},
	],
};
